import { ConfigProvider as AntdConfigProvider, theme as antdTheme } from 'antd'
import enGB from 'antd/locale/en_GB'
import React from 'react'

import { ThemeContext } from '../ThemeContext'
import { Theme, useTheme } from '@/hooks/useTheme'
import { PageMetadata } from '@/pages/_app'
import { darkTheme, defaultTheme } from '@/styles/theme'

type ThemeProviderProps = {
  children: React.ReactNode
  pageMetadata: PageMetadata
}

export function ThemeProvider({
  children,
  pageMetadata,
}: ThemeProviderProps): JSX.Element {
  const { themeLocalStorageValue, onThemeChange, currentTheme } = useTheme()

  const isDarkMode = currentTheme === Theme.dark
  const isLightMode = currentTheme === Theme.light

  const overrideTheme = pageMetadata?.isThemeLightMode
    ? null
    : isDarkMode && darkTheme

  return (
    <ThemeContext.Provider
      value={{
        currentTheme,
        isDarkMode,
        isLightMode,
        onThemeChange,
        themeLocalStorageValue,
      }}
    >
      <AntdConfigProvider
        locale={enGB}
        theme={{
          ...defaultTheme(overrideTheme),
          algorithm: getTheme(currentTheme),
        }}
      >
        {children}
      </AntdConfigProvider>
    </ThemeContext.Provider>
  )
}

function getTheme(theme: Theme) {
  const { defaultAlgorithm, darkAlgorithm } = antdTheme

  switch (theme) {
    case Theme.dark:
      return darkAlgorithm
    case Theme.light:
      return defaultAlgorithm
    default:
      return defaultAlgorithm
  }
}
